import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { LanguageProvider } from "./i18n/LanguageContext";
import { ProfileLanguageSync } from "./i18n/ProfileLanguageSync";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { usePageView } from "./hooks/usePageView";
import { LandingPage } from "./pages/LandingPage";
import { LoginPage } from "./pages/LoginPage";
import { LibraryPage } from "./pages/LibraryPage";
import { SnippetsPage } from "./pages/SnippetsPage";
import { DotPhrasesPage } from "./pages/DotPhrasesPage";
import { WebsitesPage } from "./pages/WebsitesPage";
import { ProfilePage } from "./pages/ProfilePage";
import { TryOutPage } from "./pages/TryOutPage";
import { PublicPlaygroundPage } from "./pages/PublicPlaygroundPage";
import { DevTextareaPage } from "./pages/DevTextareaPage";
import "./App.css";

const AnalyticsRouteTracker = () => {
  usePageView();
  return null;
};

const App = () => (
  <LanguageProvider>
    <AuthProvider>
      <BrowserRouter>
        <ProfileLanguageSync />
        <AnalyticsRouteTracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/use-desktop" element={<Navigate to="/" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/playground" element={<PublicPlaygroundPage />} />
          <Route path="/test" element={<DevTextareaPage />} />
          <Route
            path="/app"
            element={<Navigate to="/app/snippets" replace />}
          />
          <Route
            path="/app/snippets"
            element={
              <ProtectedRoute>
                <SnippetsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/dotphrases"
            element={
              <ProtectedRoute>
                <DotPhrasesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/websites"
            element={
              <ProtectedRoute>
                <WebsitesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/library"
            element={
              <ProtectedRoute>
                <LibraryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/try"
            element={
              <ProtectedRoute>
                <TryOutPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/library"
            element={<Navigate to="/app/library" replace />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </LanguageProvider>
);

export default App;
